import { DoubleSide, ShaderMaterial, Texture } from 'three';
import hipSpineXRayVertexShader from '@/lib/threeScene/materials/shaders/hipSpineXRay.vertex.shader.glsl';
import hipSpineXRayFragmentShader from '@/lib/threeScene/materials/shaders/hipSpineXRay.fragment.shader.glsl';

export type HipSpineXrayMaterialParams = {
    texture?: Texture;
    brightness?: number;
    contrast?: number;
};

/**
 * Create a Three.js {@link ShaderMaterial} for displaying a hip spine X-ray image
 * with adjustable brightness and contrast via uniforms.
 *
 * - `uBrightness` (float): additive brightness offset, default 0.0
 * - `uContrast` (float): multiplicative contrast scale around mid-gray, default 1.0
 * - `uTexture` (sampler2D): the source X-ray image texture
 */
export function makeHipSpineXRayMaterial(params?: HipSpineXrayMaterialParams): ShaderMaterial {
    return new ShaderMaterial({
        name: 'hip-spine-xray',
        uniforms: {
            uTexture: { value: params?.texture ?? null },
            uBrightness: { value: params?.brightness ?? 0.0 },
            uContrast: { value: params?.contrast ?? 1.0 },
        },
        vertexShader: hipSpineXRayVertexShader,
        fragmentShader: hipSpineXRayFragmentShader,
        side: DoubleSide,
        // Radiograph alpha is always 1 — opaque pass keeps the image behind
        // the landmark/angle overlays that share z=0 in the scene.
        transparent: false,
        depthWrite: true,
    });
}
